import { render } from "./SobreConceitos.vue?vue&type=template&id=04dd284f"
import script from "./SobreConceitos.vue?vue&type=script&lang=js"
export * from "./SobreConceitos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__